module.exports = __webpack_public_path__ + "img/DN-Proximity.250a79e3.svg";